// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1WzzP","label":"Radio_label__1trR6","checkMark":"Radio_checkMark__2hxeZ","disabled":"Radio_disabled__1rOjV"};